export const avoir = {
  title: "Avoirs",
  search_placeholder: "Rechercher",
  all: "Tous",
  draft: "Brouillons",
  finalized: "À valider",
  paid: "Validés",
  to_pay: "Publiés",
  client_name: "Client",
  empty_title: "Créez un avoir",
  empty_description:
    "Créez et envoyez vos avoirs à vos clients en toute simplicité",
  select_client_first: "Sélectionnez d'abord un client",
  choose_client: "Choisir un client",
  create_button: "Créer un avoir",
  company_name: "Nom de l'entreprise",
  new_invoice: "Nouvel avoir de vente",
  recipient: "Destinataire",
  new_client: "Nouveau client",
  choose_company: "Sélectionner une entreprise",
  new_companies: "Nouvelle entreprise",
  Informations: "Informations",
  currency: "Devise (requis)",
  checkboxTVA: "TVA non applicable",
  SellerName: "Nom du fournisseur",
  SellerEmail: "Email du fournisseur",
  SellerAdress: "Adresse du fournisseur",
  InvoiceNumber: "Numéro de l'avoir",
  CommandNumber: "Numéro de commande",
  InvoiceDate: "Date de l'avoir",
  DueDateInvoice: "Date d'échéance",
  TypeInvoice: "Type d'avoir",
  articles: "Articles",
  type: "Type",
  Quantity: "Quantité",
  PriceHT: "Prix unitaire (HT)",
  TotalHt: "Total (HT)",
  TVA: "TVA",
  Débours: "Débours",
  Reduction: "Remise %",
  AddDebours: "+ Ajouter un débours",
  Réglement: "Règlement",
  conditions: "Conditions de règlement",
  reglementMode: "Mode de règlement",
  IntérétsRetard: "Intérêts de retard",
  new_IntérétsRetard: "Pas d’intérêts de retard",
  new_IntérétsRetard2: "Compte bancaire (IBAN)",
  new_conditions: "45 jours fin de mois",
  new_reglementMode: "Virement bancaire",
  client: "Client",
  clientName: "Nom du client",
  ClientEmail: "Email du client",
  ClientAdress: "Adresse du client",
  amount: "Montant",
  due_date: "Date d'échéance",
  status: "Statut",
  submit: "Enregistrer l'avoir",
  DocumentText: "Textes affichés sur le document",
  Keywords: "Mots-clés",
  ChooseKeywords: "Ajouter/Sélectionner des mots-clés",
  Notes: "Notes",
  PaimentSolution: "Solution de paiement rapide",
  add_line: "+ Ajouter une ligne",
  end_date: "Jusqu'au",
  start_date: "Date de l'avoir",
  cancel: "Annuler",
  preview: "Prévisualiser",
  save_draft: "Sauvegarder le brouillon",
  finalize: "Finaliser l'avoir",
  created_success: "Avoir créé avec succès !",
  creation_failed: "Échec de la création de l'avoir",
  line_removed: "Ligne supprimée",
  line_added: "Nouvelle ligne ajoutée",
  from: "De",
  company: "Entreprise",
  find_invoice: "Choisir la facture",
  title_pdf_preview: "Avoir provisoire",

  company_required: "L'entreprise est requise",
  invoice_required: "La facture d'origine est requise",
  client_required: "Le client est requis",
  invalid_date: "Date invalide",
  date_required: "La date est requise",
  invalid_amount: "Montant invalide",
  positive_amount: "Le montant doit être positif",
  amount_required: "Le montant est requis",

  ref: "Réf",
  ref_invoice: "Réf facture",
  total_ht: "Total HT",
  date: "Date",
  actions: "Actions",

  chooseClient: "Choisir un client",
  chooseInvoice: "Choisir une facture",
  invoiceTotal: "Montant de la facture",
  note: "Note",
  creditAmount: "Montant à avoir",
  invoiceRequired: "La sélection d'une facture est requise",
  amountRequired: "Le montant est requis",
  amountMax: "Le montant maximal est dépassé",
  positiveAmount: "Veuillez saisir un montant positif",
  valid: "Valider",
};
